import React, { useState } from 'react'
import { login } from '../api/api'
import { AxiosError } from 'axios' // Импортируем тип AxiosError

interface AuthProps {
	onLogin: (token: string) => void
}

const Auth: React.FC<AuthProps> = ({ onLogin }) => {
	const [username, setUsername] = useState('')
	const [password, setPassword] = useState('')
	const [error, setError] = useState<string | null>(null)

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault()
		setError(null)

		try {
			const response = await login(username, password)
			onLogin(response.data.token)
		} catch (err) {
			const axiosError = err as AxiosError<{ message?: string }> // Типизируем как AxiosError с возможным полем message
			if (axiosError.response) {
				setError(axiosError.response.data.message || 'An error occurred')
			} else {
				setError('An unexpected error occurred')
			}
		}
	}

	return (
		<form onSubmit={handleSubmit} className='w-full'>
			<div className='mb-4'>
				<input
					type='text'
					value={username}
					placeholder='Username'
					onChange={e => setUsername(e.target.value)}
					className='w-full p-2 bg-transparent text-sky-800 border-b-2 border-sky-600 rounded focus:outline-none focus:ring-2 focus:ring-cyan-600'
					required
				/>
			</div>
			<div className='mb-4'>
				<input
					type='password'
					value={password}
					placeholder='Password'
					onChange={e => setPassword(e.target.value)}
					className='w-full p-2 bg-transparent text-sky-800 border-b-2 border-sky-600 rounded focus:outline-none focus:ring-2 focus:ring-cyan-600'
					required
				/>
			</div>
			{error && <p className='text-red-500 mb-4'>{error}</p>}
			<button
				type='submit'
				className='mt-4 bg-sky-600 hover:bg-sky-700 text-white font-semibold py-4 px-8 rounded flex items-center space-x-2 transition duration-300 w-full justify-center'
			>
				Login
			</button>
		</form>
	)
}

export default Auth
